// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateWorkbookMutationVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  sourceFingerprint: Types.Scalars["ID"]["input"];
  issueId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  issueExplainId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  queryText: Types.Scalars["String"]["input"];
  normalizedQuery: Types.Scalars["String"]["input"];
  description?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  newAliases?: Types.InputMaybe<Types.Scalars["JSON"]["input"]>;
}>;

export type CreateWorkbookMutation = {
  __typename?: "Mutation";
  createWorkbook: {
    __typename?: "CreateWorkbookPayload";
    workbookId?: string | null;
    variantId?: string | null;
  };
};

export const CreateWorkbookDocument = gql`
  mutation CreateWorkbook(
    $databaseId: ID!
    $name: String!
    $sourceFingerprint: ID!
    $issueId: ID
    $issueExplainId: ID
    $queryText: String!
    $normalizedQuery: String!
    $description: String
    $newAliases: JSON
  ) {
    createWorkbook(
      databaseId: $databaseId
      name: $name
      sourceFingerprint: $sourceFingerprint
      issueId: $issueId
      issueExplainId: $issueExplainId
      queryText: $queryText
      normalizedQuery: $normalizedQuery
      description: $description
      newAliases: $newAliases
    ) {
      workbookId
      variantId
    }
  }
`;
export type CreateWorkbookMutationFn = Apollo.MutationFunction<
  CreateWorkbookMutation,
  CreateWorkbookMutationVariables
>;

/**
 * __useCreateWorkbookMutation__
 *
 * To run a mutation, you first call `useCreateWorkbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkbookMutation, { data, loading, error }] = useCreateWorkbookMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      name: // value for 'name'
 *      sourceFingerprint: // value for 'sourceFingerprint'
 *      issueId: // value for 'issueId'
 *      issueExplainId: // value for 'issueExplainId'
 *      queryText: // value for 'queryText'
 *      normalizedQuery: // value for 'normalizedQuery'
 *      description: // value for 'description'
 *      newAliases: // value for 'newAliases'
 *   },
 * });
 */
export function useCreateWorkbookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkbookMutation,
    CreateWorkbookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkbookMutation,
    CreateWorkbookMutationVariables
  >(CreateWorkbookDocument, options);
}
export type CreateWorkbookMutationHookResult = ReturnType<
  typeof useCreateWorkbookMutation
>;
export type CreateWorkbookMutationResult =
  Apollo.MutationResult<CreateWorkbookMutation>;
export type CreateWorkbookMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkbookMutation,
  CreateWorkbookMutationVariables
>;
